module.exports = __webpack_public_path__ + "img/Cape-Verde.4304cc0d.png";